import useJwt from '@/auth/jwt/useJwt'

const service = useJwt;

export default function request(...arg){
    //console.debug(service.axiosIns);
    return service.axiosIns(...arg);
}
